import React, { useEffect, useState } from "react";

import { Link, useNavigate, useLocation } from "react-router-dom";
import DropdownRight from "./DropdownRight";
import { Formik } from "formik";
import * as Yup from "yup";
import { ErrorMessage } from "formik";
import { SpinnerCircular } from "spinners-react";
import { ToastContainer } from "react-toastify";
import http from "../services/http";
import GetToken from "../services/Storage";
import { showToast } from "./ShowToast";
import arrowleft from "../assets/images/arrow-left.png";
import Nav from "./Nav";

const AddNewAssistant = () => {
  const [loading, setLoading] = useState(false);
  const token = GetToken.get("xAuthToken");
  const [error, setError] = useState("");

  const location = useLocation();

  const { id } = location.state;
  console.log("id---->", id);

  const navigate = useNavigate();
  const initialValues = {
    name: "",
    email: "",
    pin: "",
  };
  const validationSchema = Yup.object({
    name: Yup.string().required("Required"),
    email: Yup.string().email().required("Required"),
    pin: Yup.string().required("Required"),
  });

  const onSubmit = async (values, { resetForm }) => {
    console.log("values---->", values);
    setLoading(true);
    http
      .post(`api/admin/coach/assistcoaches?token=${token}`, {
        name: values.name,
        email: values.email,
        pin: values.pin,
        team_id: id,
      })
      .then((res) => {
        setLoading(false);

        console.log("response---", res.data);
        showToast("success", res.data.message);

        resetForm();
        setError("");
      })
      .catch((error) => {
        setLoading(false);

        console.log("error ", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message);
          }
        }
      });
  };

  return (
    <body>
      <div className="wrapper">
        <Nav
        //  sidebarClass={toggle ? "show" : "hide"}
        />

        <div id="content">
          <header>
            <div class="dashboard_header">
              <div class="left-side d-flex ">
                <button
                  onClick={() => navigate(-1)}
                  type="button"
                  className="btn btn-link  "
                >
                  {" "}
                  <img src={arrowleft} className="img-fluid" />{" "}
                </button>
                <h1>Add New Assistant Coach</h1>{" "}
              </div>
              <DropdownRight />
            </div>
          </header>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, handleChange, handleBlur, handleSubmit }) => (
              <>
                <div className="dashbord_content">
                  <div className="dashobord_inner new_team_add">
                    <h5 className="my-3">General Info</h5>
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-4 col-sm-6">
                          <div className="fomr-group">
                            <input
                              name="name"
                              onChange={handleChange("name")}
                              onBlur={handleBlur("name")}
                              value={values.name}
                              className="custom_input form-control"
                              placeholder="Name"
                            />
                            <div
                              style={{
                                color: "red",
                              }}
                            >
                              <ErrorMessage name="name" />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-6">
                          <div className="fomr-group">
                            <input
                              type="email"
                              name="email"
                              onChange={handleChange("email")}
                              onBlur={handleBlur("email")}
                              value={values.email}
                              className="custom_input form-control"
                              placeholder=" email"
                            />
                            <div
                              style={{
                                color: "red",
                              }}
                            >
                              <ErrorMessage name="email" />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-6">
                          <div className="fomr-group">
                            <input
                              name="pin"
                              onChange={handleChange("pin")}
                              onBlur={handleBlur("pin")}
                              value={values.pin}
                              className="custom_input form-control"
                              placeholder="pin"
                            />
                            <div
                              style={{
                                color: "red",
                              }}
                            >
                              <ErrorMessage name="pin" />
                            </div>
                          </div>
                        </div>
                        <h6 style={{ color: "red" }}>{error}</h6>
                        <div className="col-12 d-flex justify-content-end">
                          <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                            <button
                              onClick={() => navigate(-1)}
                              type="button"
                              className=" them_btn_ouline  "
                            >
                              Cancel
                            </button>

                            <button
                              type="button"
                              to="/advancedSecuritySettings"
                              onClick={handleSubmit}
                              className=" them_btn  "
                            >
                              {loading ? (
                                <SpinnerCircular
                                  style={{ height: "40", marginTop: "7" }}
                                />
                              ) : (
                                "  Save"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </>
            )}
          </Formik>
        </div>
      </div>
      <ToastContainer />
    </body>
  );
};

export default AddNewAssistant;
